import { render, staticRenderFns } from "./PreviewDocumentComponent.vue?vue&type=template&id=45b03a5d&scoped=true"
import script from "./PreviewDocumentComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewDocumentComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreviewDocumentComponent.vue?vue&type=style&index=0&id=45b03a5d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b03a5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b03a5d')) {
      api.createRecord('45b03a5d', component.options)
    } else {
      api.reload('45b03a5d', component.options)
    }
    module.hot.accept("./PreviewDocumentComponent.vue?vue&type=template&id=45b03a5d&scoped=true", function () {
      api.rerender('45b03a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/FacturaEDialog/components/PreviewDocumentComponent.vue"
export default component.exports